export class AlgorithmSupportInfo {
  constructor(private readonly clientSupported: string[] | null, private readonly serverSupported: string[] | null, private readonly selected: string | null) {}

  getClientSupported() {
    return this.clientSupported ?? [];
  }

  getServerSupported() {
    return this.serverSupported ?? [];
  }

  getSelected() {
    return this.selected;
  }
}
